export enum LayoutType {
  BALANCE = 2,
  LEFT = 1,
  RIGHT = 0,
}

export enum MindmapStyle {
  FOUR = 4,
  ONE = 1,
  THREE = 3,
  TWO = 2,
}
